import Footers from './footers';
import OrderDetailsModal from './OrderDetailsModal';

export default {
  Footers,
  OrderDetailsModal,
};
